export default __webpack_public_path__ + "static/media/failure.6a495e9b.svg";